import { render } from "./DeleteShiftButton.vue?vue&type=template&id=1af6c12c&ts=true"
import script from "./DeleteShiftButton.vue?vue&type=script&lang=ts"
export * from "./DeleteShiftButton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__